import React, { useState, useEffect } from "react";
import Sidebar from '../../../composant_reutilisable/sidebar';
import Navbar from "../../../composant_reutilisable/navbar";
import useAuth from '../../../composant_reutilisable/useAuth';
import { Link } from "react-router-dom";
import { BsBuilding } from "react-icons/bs";
import { Modal, Button, Form, ProgressBar } from "react-bootstrap";
import {
    FaEdit, FaPlus, FaTrash, FaEllipsisV,
    FaSortAmountUp, FaSortAmountDown,
    FaArrowLeft,
    FaArrowRight,
    FaFileImport,
    FaFileExport,
    FaChevronUp,
    FaChevronDown,
    FaQuestionCircle,
    FaCogs,
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { FaRoadBarrier } from "react-icons/fa6";
import GlossaireSidebar from '../../../composant_reutilisable/glossaireSidebar';
import axios from "axios";
import Pas_acces from "../../../composant_reutilisable/pas_acces";
import Select from 'react-select';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';

const ListeParcs = () => {
    useAuth();
    const navigate = useNavigate();

    const [showInfo, setShowInfo] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingAjout, setIsLoadingAjout] = useState(false);
    const [sortConfig, setSortConfig] = useState({
        key: "id",
        direction: "descending",
    });
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    const [parcs, setParcs] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModifierModal, setShowModifierModal] = useState(false);
    const [showConfigurerModal, setShowConfigurerModal] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Parcs";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);
    const [nouveauParc, setNouveauParc] = useState({
        nom_parc: "",
        email_parc: "",
        type_parc: "",
        tel_parc: "",
        pays_parc: "",
        code_pays: "",
    });

    const [parcSelectionne, setParcSelectionne] = useState({
        nom_parc: '',
        email_parc: '',
        type_parc: '',
        tel_parc: "",
        pays_parc: "",
        code_pays: "",
        delai_parc: "",
        delai_route: "",
    });

    const handleSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
    };

    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    }

    // Récupération des parcs
    const fetchParcs = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
            if (response.ok) {
                const data = await response.json();
                setParcs(data);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des parcs:", error);
        }
    };

    useEffect(() => {
        fetchParcs();
        fetchPays();
    }, []);

    // Filtrage
    const parcsFiltres = parcs.filter(parc =>
        parc?.nom_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.tel_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.email_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.type_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.ref_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.pays_parc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.date_creation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.delaiParc?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parc?.delaiRoute?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Tri des données
    const parcsTries = [...parcsFiltres].sort((a, b) => {
        if (sortConfig.key) {
            const valueA = a[sortConfig.key]?.toString().toLowerCase() || "";
            const valueB = b[sortConfig.key]?.toString().toLowerCase() || "";
            if (valueA < valueB) return sortConfig.direction === "ascending" ? -1 : 1;
            if (valueA > valueB) return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
    });


    const [pays, setPays] = useState([]);
    const fetchPays = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-nationalites/`);
            const data = await response.json();
            const formattedCountries = data.map((country) => ({
                value: country.pays,
                label: country.pays,
                code: country.code_pays
            }));
            setPays(formattedCountries);
        } catch (error) {
            console.error("Erreur lors du chargement des pays :", error);
        }
    };

    // Pagination
    const totalItems = parcsFiltres.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const parcsAffiches = parcsTries.slice(indexOfFirstItem, indexOfLastItem);

    const handleSelectionParc = (parc) => {
        setParcSelectionne(parc);
    };

    // Gestion du modal
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNouveauParc(prev => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        // Initialiser avec "22901" si le champ tel est vide
        if (!nouveauParc?.tel_parc) {
            setNouveauParc(prev => ({ ...prev, tel_parc: "22901" }));
        }
    }, []);


    const handlePhoneChange = (value, country) => {
        // Pour tous les pays, d'abord nettoyer la valeur
        const numericValue = value.replace(/\D/g, '');

        // Si le pays est Bénin (229)
        if (country.dialCode === "229") {
            // Si la valeur est vide ou ne commence pas par 22901, on force le format
            if (!numericValue.startsWith('22901') || numericValue.length < 5) {
                // Garder les chiffres saisis après 229 (max 8 chiffres)
                const userDigits = numericValue.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setNouveauParc(prev => ({ ...prev, tel_parc: '22901' + userDigits }));
                return;
            }

            // Limiter à 13 chiffres maximum (22901 + 8 chiffres)
            const limitedValue = numericValue.slice(0, 13);
            setNouveauParc(prev => ({ ...prev, tel_parc: limitedValue }));
        } else {
            // Pour les autres pays, utiliser juste le code pays + numéro saisi
            // Ne pas ajouter de "01" automatique
            setNouveauParc(prev => ({ ...prev, tel_parc: numericValue }));
        }
    };

    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     let formattedValue = value;
    //     if (name === 'nom_parc') {
    //         formattedValue = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    //     }

    //     setNouveauParc(prev => ({
    //         ...prev,
    //         [name]: formattedValue
    //     }));
    // };


    const handleAjouterParc = async () => {
        const erreurs = [];

        if (!nouveauParc.nom_parc.trim()) {
            erreurs.push("Le nom du parc est obligatoire.");
        }

        if (!nouveauParc.tel_parc.trim()) {
            erreurs.push("Le numéro de téléphone du parc est obligatoire.");
        }

        if (!nouveauParc.email_parc.trim()) {
            erreurs.push("L'email du parc est obligatoire.");
        }

        if (!nouveauParc.type_parc) {
            erreurs.push("Le type de parc est obligatoire.");
        }

        if (erreurs.length > 0) {
            showAlertModal(erreurs.join(" "), "danger");
            return;
        }

        setIsLoadingAjout(true);

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-parc/${user_id}/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    ...nouveauParc,
                    pays_parc: nouveauParc.pays_parc, // Nom du pays
                    code_pays: nouveauParc.code_pays  // Code du pays
                }),
            });

            if (response.ok) {
                fetchParcs();
                setNouveauParc({ nom_parc: "", email_parc: "", type_parc: "", pays_parc: "", code_pays: "" });
                handleCloseModal();
                showAlert("Parc ajouté avec succès", "success");
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.message || "Erreur lors de l'ajout du parc", "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlertModal("Une erreur est survenue. Veuillez réessayer.", "danger");
        } finally {
            setIsLoadingAjout(false);
        }
    };

    const handleShowDeleteModal = (parc) => {
        setParcSelectionne(parc);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeleteParc = async () => {
        if (parcSelectionne) {
            
            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-parc/${parcSelectionne?.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    setShowDeleteModal(false);
                    setParcSelectionne(null);
                    showAlert('Parc supprimé avec succès !');
                    fetchParcs();
                } else {
                    console.error('Erreur lors de la suppression du parc');
                    showAlert('Erreur lors de la suppression', 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlert('Erreur réseau', 'danger');
            }
        }
    };

    const handleShowModifierModal = (parc) => {
        setParcSelectionne(parc);
        setShowModifierModal(true);
    };

    const handleCloseModifierModal = () => {
        setShowModifierModal(false);
    };

    const convertirDepuisSecondes = (secondes) => {
        if (!secondes) return { heures: 0, minutes: 0 }; // défaut

        const heures = Math.floor(secondes / 3600);
        const minutes = Math.floor((secondes % 3600) / 60);

        return { heures, minutes };
    };

    const handleShowConfigurerModal = (parc) => {
        setParcSelectionne(parc);

        // 🔹 délai parc
        const parcConverti = convertirDepuisSecondes(parc.delai_parc);
        setHeuresParc(parcConverti.heures);
        setMinutesParc(parcConverti.minutes);

        // 🔹 délai route
        const routeConverti = convertirDepuisSecondes(parc.delai_route);
        setHeuresRoute(routeConverti.heures);
        setMinutesRoute(routeConverti.minutes);

        setShowConfigurerModal(true);
    };

    const handleCloseConfigurerModal = () => {
        setShowConfigurerModal(false);
    };


    const handleModifierParc = async () => {
        if (parcSelectionne) {
            const erreurs = [];

            if (!parcSelectionne?.nom_parc.trim()) {
                erreurs.push("Le nom du parc est obligatoire.");
            }

            if (!parcSelectionne?.tel_parc.trim()) {
                erreurs.push("Le numéro de téléphone du parc est obligatoire.");
            }

            if (!parcSelectionne?.email_parc.trim()) {
                erreurs.push("L'email du parc est obligatoire.");
            }

            if (!parcSelectionne?.type_parc) {
                erreurs.push("Le type de parc est obligatoire.");
            }

            if (erreurs.length > 0) {
                showAlertModal(erreurs.join(" "), "danger");
                return;
            }

            const token = localStorage.getItem('access_token');
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/modifier-parc/${parcSelectionne?.id}/${user_id}/`,
                    {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            nom_parc: parcSelectionne?.nom_parc,
                            email_parc: parcSelectionne?.email_parc,
                            type_parc: parcSelectionne?.type_parc,
                            tel_parc: parcSelectionne?.tel_parc,
                            pays_parc: parcSelectionne?.pays_parc,
                            code_pays: parcSelectionne?.code_pays // Ajouter le code pays
                        }),
                    }
                );

                if (response.ok) {
                    fetchParcs();
                    showAlertModal('Parc modifié avec succès !');
                    handleCloseModifierModal();
                } else {
                    const errorData = await response.json();
                    showAlertModal(errorData.message || "Erreur lors de l'ajout du parc", "danger");
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
                showAlertModal('Erreur réseau', 'danger');
            }
            // finally {
            //     setShowModifierModal(false);
            // }
        }
    };



    const handleSelectChange = (selectedOption, { name }) => {
        setNouveauParc(prev => ({
            ...prev,
            pays_parc: selectedOption ? selectedOption.value : '', // Nom du pays
            code_pays: selectedOption ? selectedOption.code : ''
        }));
    };

    const handleSelectModifChange = (selectedOption, { name }) => {
        setParcSelectionne(prev => ({
            ...prev,
            pays_parc: selectedOption ? selectedOption.value : '', // Nom du pays
            code_pays: selectedOption ? selectedOption.code : ''
        }));
    };

    const typesParc = ['national', 'international'];

    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);

    const handleShowImportModal = () => {
        setShowImportModal(true);
    };

    const handleCloseImportModal = () => {
        setShowImportModal(false);
    };
    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleImport = () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);

            setIsImporting(true);
            setProgress(0);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${process.env.REACT_APP_HOTE}/importer-parc/${user_id}/`, true);

            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    setProgress(percentComplete);
                }
            });

            xhr.onload = () => {
                const data = JSON.parse(xhr.responseText);
                if (xhr.status === 200) {
                    console.log("Importation réussie :", data);
                    setShowImportModal(false);
                    setAlert({ message: 'Importation réussie !', type: 'success' });
                    fetchParcs();

                    setTimeout(() => {
                        setAlert({ message: '', type: '' });
                    }, 3000);
                } else {
                    console.error("Erreur lors de l'importation :", xhr.responseText);
                    setAlert({ message: data.message, type: 'danger' });
                    handleCloseImportModal()
                }
                setIsImporting(false);
            };

            xhr.onerror = () => {
                console.error("Erreur lors de l'importation :", xhr.statusText);
                setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });

                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 5000);
                setIsImporting(false);
            };

            xhr.send(formData);
        } else {
            alert("Veuillez sélectionner un fichier à importer.");
        }
    };

    const [showExportModal, setShowExportModal] = useState(false);
    const [isLoadingBouton, setIsLoadingBouton] = useState(false);

    const handleExport = async () => {
        setIsLoadingBouton(true);
        const token = localStorage.getItem('access_token');
        try {
            const url = `${process.env.REACT_APP_HOTE}/export-parc/${user_id}/`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/csv",
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error("Erreur lors de l'export des parcs");
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "parcs_export.csv";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);

            setShowExportModal(false);
            showAlert("Exportation des parcs terminée avec succès !");
        } catch (error) {
            console.error("Erreur d'export:", error);
            showAlert("Une erreur est survenue lors de l'export des parcs.", 'danger');
            setShowExportModal(false)
        } finally {
            setIsLoadingBouton(false);
        }
    };


    const [heuresParc, setHeuresParc] = useState(0);
    const [minutesParc, setMinutesParc] = useState(0);

    const [heuresRoute, setHeuresRoute] = useState(0);
    const [minutesRoute, setMinutesRoute] = useState(0);

    const convertirEnSecondes = (h, m) => {
        return (h * 3600) + (m * 60);
    };

    const handleConfigurerDelai = async () => {

        if (!parcSelectionne) return;
        const erreurs = [];

        // Conversion
        const delaiParc = convertirEnSecondes(heuresParc, minutesParc);
        const delaiRoute = convertirEnSecondes(heuresRoute, minutesRoute);

        const token = localStorage.getItem('access_token')
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/configurer-delai-parc/${parcSelectionne?.id}/${user_id}/`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        delai_parc: delaiParc,
                        delai_route: delaiRoute
                    }),
                }
            );

            if (response.ok) {
                fetchParcs();
                showAlertModal('Configuration effectuée avec succès !');
            } else {
                const errorData = await response.json();
                showAlertModal(errorData.message || "Erreur lors de la configuration des délais du parc", "danger");
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlertModal('Erreur réseau', 'danger');
        }
        // finally {
        //     setShowConfigurerModal(false);
        // }

    };



    const [showGlossary, setShowGlossary] = useState(false);

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            const token = localStorage.getItem('access_token');
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`,
                  {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Elementaires")) {
        return (
            <Pas_acces />
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2></h2>
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaRoadBarrier size={25} className='mr-2' />Parc
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-elementaires'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Aide"
                                    onClick={() => setShowGlossary(true)}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Administration des parcs de véhicules.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Elementaires`}> Elémentaires</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Parcs
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Liste des parcs</h5>
                            <div className="d-flex mt-md-0" style={{ gap: '10px' }}>
                                <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={handleOpenModal}>
                                    <FaPlus />
                                    <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                </button>
                                {/* <button className="btn btn-success mr-2 d-flex align-items-center justify-content-center" onClick={handleShowImportModal}>
                                    <FaFileImport />
                                    <span className="d-none d-sm-inline ml-2">Importer</span>
                                </button>
                                <button className="btn btn-success d-flex align-items-center justify-content-center" onClick={() => setShowExportModal(true)}>
                                    <FaFileExport />
                                    <span className="d-none d-sm-inline ml-2">Exporter</span>
                                </button> */}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div className="me-2">
                                                <select
                                                    value={itemsPerPage}
                                                    onChange={handleItemsPerPageChange}
                                                    className="form-select bg-default p-1"
                                                    style={{
                                                        width: "auto",
                                                        border: "1px black solid",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                    <option value={50}>50</option>
                                                </select>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control mr-2"
                                                    style={{ maxWidth: "150px", width: "100%" }}
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                                <thead>
                                                    <tr>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("ref_parc")}>
                                                            Référence du parc
                                                            {sortConfig.key === "ref_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-justify" onClick={() => handleSort("nom_parc")}>
                                                            Nom du parc
                                                            {sortConfig.key === "nom_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("tel_parc")}>
                                                            Téléphone du parc
                                                            {sortConfig.key === "tel_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("email_parc")}>
                                                            Email du parc
                                                            {sortConfig.key === "email_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("type_parc")}>
                                                            Type de parc
                                                            {sortConfig.key === "type_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-secondary text-wrap d-none d-md-table-cell text-center" onClick={() => handleSort("pays_parc")}>
                                                            Pays
                                                            {sortConfig.key === "pays_parc"}{sortConfig.direction === "ascending" ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                        </th>
                                                        <th className="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">Chargement...</td>
                                                        </tr>
                                                    ) : parcsAffiches.length > 0 ? (
                                                        parcsAffiches.map((parc) => (
                                                            <tr key={parc.id}>
                                                                {/* <td className="d-none d-md-table-cell text-justify">{parc.nom_parc}</td> */}
                                                                <td className="d-none d-md-table-cell">{parc.ref_parc}</td>
                                                                <td className="d-none d-md-table-cell text-justify">{parc.nom_parc.charAt(0).toUpperCase() + parc.nom_parc.slice(1).toLowerCase()}</td>
                                                                <td className="d-none d-md-table-cell text-center">{parc.tel_parc}</td>
                                                                <td className="d-none d-md-table-cell text-center">{parc.email_parc}</td>
                                                                <td className="d-none d-md-table-cell text-center">{parc.type_parc}</td>
                                                                <td className="d-none d-md-table-cell text-center">{parc.pays_parc} ({parc.code_pays})</td>
                                                                <td className="text-center" style={{ position: 'relative' }}>
                                                                    <div>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenDropdownId(openDropdownId === parc.id ? null : parc.id);
                                                                            }}
                                                                            style={{
                                                                                background: 'none',
                                                                                border: 'none',
                                                                                padding: '0 5px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV title="Actions" />
                                                                        </button>

                                                                        {openDropdownId === parc.id && (
                                                                            <div
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '150px',
                                                                                    right: '50px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowModifierModal(parc);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                                    <span>Modifier</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowDeleteModal(parc);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaTrash className="mr-2" style={{ color: "red" }} size={14} />
                                                                                    <span>Supprimer</span>
                                                                                </div>

                                                                                <div style={{ borderTop: '1px solid #eee' }} />

                                                                                <div
                                                                                    style={{
                                                                                        padding: '8px 16px',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        cursor: 'pointer',
                                                                                        ':hover': {
                                                                                            backgroundColor: '#f8f9fa'
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        handleShowConfigurerModal(parc);
                                                                                        setOpenDropdownId(null);
                                                                                    }}
                                                                                >
                                                                                    <FaCogs className="mr-2" style={{ color: "black" }} size={14} />
                                                                                    <span>Configuration délai</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center">Aucun parc trouvé.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Pagination */}
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div>
                                                {parcsFiltres.length === 0
                                                    ? "Aucun élément à afficher"
                                                    : `Affichage de ${indexOfFirstItem + 1} à ${Math.min(indexOfLastItem, parcsFiltres.length)} sur ${parcsFiltres.length}`}
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                    className={`btn ${currentPage === 1 ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === 1}
                                                >
                                                    <FaArrowLeft />
                                                </button>

                                                {(() => {
                                                    const pagesToShow = 5;
                                                    let startPage = Math.max(
                                                        1,
                                                        currentPage - Math.floor(pagesToShow / 2)
                                                    );
                                                    let endPage = Math.min(
                                                        totalPages,
                                                        startPage + pagesToShow - 1
                                                    );

                                                    if (endPage - startPage < pagesToShow - 1) {
                                                        startPage = Math.max(
                                                            1,
                                                            endPage - pagesToShow + 1
                                                        );
                                                    }

                                                    const pageButtons = [];

                                                    for (let i = startPage; i <= endPage; i++) {
                                                        pageButtons.push(
                                                            <button
                                                                key={i}
                                                                onClick={() => setCurrentPage(i)}
                                                                className={`btn ${currentPage === i
                                                                    ? "btn-default"
                                                                    : "btn-light"
                                                                    } mx-1`}
                                                            >
                                                                {i}
                                                            </button>
                                                        );
                                                    }

                                                    return pageButtons;
                                                })()}
                                                <button
                                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                    className={`btn ${currentPage === totalPages ? "btn-outline-secondary" : "btn-outline-primary"} mx-1`}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <FaArrowRight />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal d'enregistrement */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Ajouter un parc</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formParc">
                            {/* <Form.Label className="">Référence du parc</Form.Label>
                            <Form.Control
                                type="text"
                                name="ref_parc"
                                value={nouveauParc?.ref_parc || ''}
                                onChange={handleChange}
                                placeholder="Référence du parc"
                            /> */}

                            <Form.Label className="">Nom du parc</Form.Label>
                            <Form.Control
                                type="text"
                                name="nom_parc"
                                value={nouveauParc?.nom_parc || ''}
                                onChange={handleChange}
                                placeholder="Nom du parc"
                            />

                            <Form.Label className="">Email du parc</Form.Label>
                            <Form.Control
                                type="text"
                                name="email_parc"
                                value={nouveauParc?.email_parc || ''}
                                onChange={handleChange}
                                placeholder="Email du parc"
                            />

                            <Form.Label className="">Téléphone du parc</Form.Label>
                            <PhoneInput
                                name="tel_parc"
                                value={nouveauParc?.tel_parc}
                                country="bj"
                                onChange={(value, country) => handlePhoneChange(value, country)}
                                onKeyDown={(e) => {
                                    const numericValue = (nouveauParc?.tel_parc || "").replace(/\D/g, '');
                                    // Vérifier si c'est le Bénin
                                    if (numericValue.startsWith('229')) {
                                        // Empêcher la suppression du préfixe 22901
                                        if (e.key === 'Backspace' || e.key === 'Delete') {
                                            if (numericValue.length <= 5) { // 22901 = 5 chiffres
                                                e.preventDefault();
                                            }
                                        }
                                        // Empêcher d'ajouter plus de 13 chiffres
                                        else if (numericValue.length >= 13 &&
                                            !['ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                required
                                placeholder=""
                                inputStyle={{
                                    width: "100%",
                                    height: "33px",
                                    fontSize: "12px",
                                    paddingLeft: "55px"
                                }}
                                containerStyle={{ width: "100%" }}
                                inputProps={{
                                    name: "tel",
                                    required: true,
                                }}
                                dropdownStyle={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    zIndex: 1050,
                                }}
                                onCountryChange={(country) => {
                                    if (country.dialCode === "229") {
                                        // Quand on revient au Bénin, forcer le format 22901
                                        const currentNumeric = (nouveauParc?.tel_parc || "").replace(/\D/g, '');
                                        if (!currentNumeric.startsWith("22901")) {
                                            setNouveauParc(prev => ({
                                                ...prev,
                                                tel_parc: '22901' + currentNumeric.replace(/^229/, '').replace(/^0?/, '').slice(0, 8)
                                            }));
                                        }
                                    } else {
                                        // Pour les autres pays, enlever tout préfixe spécifique
                                        const currentNumeric = (nouveauParc?.tel_parc || "").replace(/\D/g, '');
                                        setNouveauParc(prev => ({
                                            ...prev,
                                            tel_parc: currentNumeric.replace(/^22901/, '').replace(/^229/, '')
                                        }));
                                    }
                                }}
                            />

                            <Form.Label className="mt-3">Type de parc</Form.Label>
                            <Form.Control
                                as='select'
                                name="type_parc"
                                value={nouveauParc?.type_parc || ''}
                                onChange={handleChange}
                            >
                                <option value="">Sélectionner un type</option>
                                <option value="national">National</option>
                                <option value="international">International</option>
                            </Form.Control>

                            <Form.Label>Pays </Form.Label>
                            <Select
                                name="pays_parc"
                                options={pays}
                                value={pays.find(option => option.value === nouveauParc.pays_parc)}
                                onChange={handleSelectChange}
                                placeholder="Sélectionner un pays..."
                                isClearable
                                required
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '42px'
                                    })
                                }}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        <strong>Annuler</strong>
                    </Button>
                    {/* <Button variant="success" onClick={handleAjouterParc}>
                        <strong>Ajouter</strong>
                    </Button> */}
                    <Button variant="success" onClick={handleAjouterParc} disabled={isLoadingAjout}>
                        {isLoadingAjout ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                            <>Ajouter</>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de confirmation de suppression */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header>
                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer <strong>{parcSelectionne?.nom_parc || " "}</strong> ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleDeleteParc}>
                        <strong>Supprimer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de modification */}
            <Modal show={showModifierModal} onHide={handleCloseModifierModal}>
                <Modal.Header>
                    <Modal.Title>Modifier le {parcSelectionne?.nom_parc}</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formParc">
                            {/* <Form.Label className="">Référence du parc</Form.Label>
                            <Form.Control
                                type="text"
                                name="ref_parc"
                                value={parcSelectionne?.ref_parc || ''}
                                onChange={(e) =>
                                    setParcSelectionne({ ...parcSelectionne, ref_parc: e.target.value })
                                }
                                placeholder="Référence du parc"
                            /> */}

                            <Form.Label className="">Nom du parc</Form.Label>
                            <Form.Control
                                type="text"
                                value={parcSelectionne?.nom_parc || ''}
                                onChange={(e) =>
                                    setParcSelectionne({ ...parcSelectionne, nom_parc: e.target.value })
                                }
                            />

                            <Form.Label className="">Email du parc</Form.Label>
                            <Form.Control
                                type="text"
                                value={parcSelectionne?.email_parc || ''}
                                onChange={(e) =>
                                    setParcSelectionne({ ...parcSelectionne, email_parc: e.target.value })
                                }
                            />

                            <Form.Label className="">Téléphone du parc</Form.Label>
                            <PhoneInput
                                name="tel_parc"
                                value={parcSelectionne?.tel_parc}
                                country="bj"
                                // onChange={(value, country) => handlePhoneChange(value, country)}
                                onChange={(value, country) => {
                                    setParcSelectionne(prev => ({
                                        ...prev,
                                        tel_parc: value
                                    }));
                                }}
                                onKeyDown={(e) => {
                                    const numericValue = (parcSelectionne?.tel_parc || "").replace(/\D/g, '');
                                    // Vérifier si c'est le Bénin
                                    if (numericValue.startsWith('229')) {
                                        // Empêcher la suppression du préfixe 22901
                                        if (e.key === 'Backspace' || e.key === 'Delete') {
                                            if (numericValue.length <= 5) { // 22901 = 5 chiffres
                                                e.preventDefault();
                                            }
                                        }
                                        // Empêcher d'ajouter plus de 13 chiffres
                                        else if (numericValue.length >= 13 &&
                                            !['ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                required
                                placeholder=""
                                inputStyle={{
                                    width: "100%",
                                    height: "33px",
                                    fontSize: "12px",
                                    paddingLeft: "55px"
                                }}
                                containerStyle={{ width: "100%" }}
                                inputProps={{
                                    name: "tel_parc",
                                    required: true,
                                }}
                                dropdownStyle={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    zIndex: 1050,
                                }}
                                onCountryChange={(country) => {
                                    if (country.dialCode === "229") {
                                        // Quand on revient au Bénin, forcer le format 22901
                                        const currentNumeric = (parcSelectionne?.tel_parc || "").replace(/\D/g, '');
                                        if (!currentNumeric.startsWith("22901")) {
                                            setParcSelectionne(prev => ({
                                                ...prev,
                                                tel_parc: '22901' + currentNumeric.replace(/^229/, '').replace(/^0?/, '').slice(0, 8)
                                            }));
                                        }
                                    } else {
                                        // Pour les autres pays, enlever tout préfixe spécifique
                                        const currentNumeric = (parcSelectionne?.tel_parc || "").replace(/\D/g, '');
                                        setParcSelectionne(prev => ({
                                            ...prev,
                                            tel_parc: currentNumeric.replace(/^22901/, '').replace(/^229/, '')
                                        }));
                                    }
                                }}
                            />

                            <Form.Label className="mt-3">Type de parc</Form.Label>
                            <Form.Control
                                as='select'
                                value={parcSelectionne?.type_parc || ''}
                                onChange={(e) =>
                                    setParcSelectionne({ ...parcSelectionne, type_parc: e.target.value })
                                }
                            >
                                <option value="">Sélectionner un type</option>
                                <option value="national">National</option>
                                <option value="international">International</option>
                            </Form.Control>

                            <Form.Label>Pays </Form.Label>
                            <Select
                                name="pays_parc"
                                options={pays}
                                value={pays.find(option => option.value === parcSelectionne?.pays_parc)}
                                onChange={handleSelectModifChange}
                                placeholder="Sélectionner un pays..."
                                isClearable
                                required
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '42px'
                                    })
                                }}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModifierModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleModifierParc}>
                        <strong>Modifier</strong>
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showImportModal} onHide={handleCloseImportModal}>
                <Modal.Header>
                    <Modal.Title>Importation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="formFile" className="mt-3">
                        <Form.Label>Choisissez un fichier à importer</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </Form.Group>
                    {isImporting && (
                        <div className="mt-3">
                            <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => handleCloseImportModal()}
                        disabled={isImporting}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => handleImport()}
                        disabled={!selectedFile || isImporting}
                    >
                        Importer
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showExportModal} onHide={() => setShowExportModal(false)}>
                <Modal.Header>
                    <Modal.Title>Exporter les parcs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Voulez-vous exporter l'ensemble des parcs au format CSV ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowExportModal(false)} disabled={isLoading}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleExport} disabled={isLoading}>
                        {isLoadingBouton ? (
                            <>
                                <span className="ms-2">Export en cours...</span>
                            </>
                        ) : (
                            "Exporter"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Configuration de délai */}
            <Modal show={showConfigurerModal} onHide={handleCloseConfigurerModal}>
                <Modal.Header>
                    <Modal.Title>Configurer les délais sur {parcSelectionne?.nom_parc}</Modal.Title>
                </Modal.Header>
                {alertModal.message && (
                    <div className={`m-2 alert alert-${alertModal.type} row justify-content-between position-relative`}>
                        <div dangerouslySetInnerHTML={{ __html: alertModal.message }} />
                        <span onClick={fermerNotif} style={{ cursor: 'pointer' }}>
                            <i className='fa fa-close'></i>
                        </span>
                    </div>
                )}
                <Modal.Body>
                    <Form>

                        {/* Délai sortie parc */}
                        <div className="p-3 mb-4 border rounded bg-light">
                            <label className="fw-bold mb-3" style={{ fontSize: "14px", fontWeight: "700" }}>
                                Délai sortie camion du parc de regroupement
                            </label>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>
                                        Heures
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Heures"
                                        value={heuresParc}
                                        min={0}
                                        onChange={(e) => setHeuresParc(Number(e.target.value))}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>
                                        Minutes
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Minutes"
                                        value={minutesParc}
                                        min={0}
                                        max={59}
                                        onChange={(e) => setMinutesParc(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>


                        {/* Délai de route */}
                        <div className="p-3 mb-4 border rounded bg-light">
                            <label className="fw-bold mb-3" style={{ fontSize: "14px", fontWeight: "700" }}>
                                Délai de route entre parc de regroupement et parc tampon
                            </label>

                            <div className="row">
                                <div className="col-md-6">
                                    <label>
                                        Heures
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Heures"
                                        value={heuresRoute}
                                        min={0}
                                        onChange={(e) => setHeuresRoute(Number(e.target.value))}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label>
                                        Minutes
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Minutes"
                                        value={minutesRoute}
                                        min={0}
                                        max={59}
                                        onChange={(e) => setMinutesRoute(Number(e.target.value))}
                                    />
                                </div>
                            </div>
                        </div>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfigurerModal}>
                        <strong>Annuler</strong>
                    </Button>
                    <Button variant="success" onClick={handleConfigurerDelai}>
                        <strong>Enregistrer</strong>
                    </Button>
                </Modal.Footer>
            </Modal>


            <GlossaireSidebar isOpen={showGlossary} onClose={() => setShowGlossary(false)} />
        </div>
    );
};

export default ListeParcs;